"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateVersion4toVersion5 = void 0;
const updateVersion4toVersion5 = (configuration) => {
    var _a;
    return {
        __type: "PreviewPageConfiguration",
        version: 5,
        video: configuration.video,
        playerConfiguration: configuration.playerConfiguration,
        content: configuration.content,
        trackingAccountId: configuration.trackingAccountId,
        trackingAccountName: configuration.trackingAccountName,
        trackingVideoId: configuration.trackingVideoId,
        trigger: (_a = configuration.trackingPreviewType) !== null && _a !== void 0 ? _a : "Review link"
    };
};
exports.updateVersion4toVersion5 = updateVersion4toVersion5;
//# sourceMappingURL=v5.js.map